import React from "react";
import PropTypes from "prop-types";
import ItemListItemBody from "./ItemListItemBody";
import ItemListItemHeader from "./ItemListItemHeader";
import EmptyScreen from "./EmptyScreen";
import { Expandable } from "folksam-ui";
import InitialRenderProvider from "providers/InitialRenderProvider/InitialRenderProvider";
const ItemList = ({ children, active }) => {
  return (
    <InitialRenderProvider>
      <Expandable initialExpanded={[active]} collapse={true}>
        {React.Children.count(children) > 0 ? children : <EmptyScreen />}
      </Expandable>
    </InitialRenderProvider>
  );
};

ItemList.propTypes = {
  children: PropTypes.node,
  active: PropTypes.string
};

ItemList.Header = ItemListItemHeader;
ItemList.Body = ItemListItemBody;

export default ItemList;
